import React from 'react';

import {motion } from 'framer-motion';

export default function AnimatedPLewa({ children, referencja, fontSize, dlugoscAnimacji }) {

    const variants = {
        hidden: { x: '300%' },
        visible: { x: 0 },
    };

    return (
            <div className="">
                <motion.div
                    initial="hidden"
                    animate={referencja ? 'visible' : 'hidden'}
                    variants={variants}
                    transition={{ duration: dlugoscAnimacji, ease: 'easeInOut' }}
                    className=''
                    style={{fontSize: fontSize}}
                >
                    {children}
                </motion.div>
            </div>
    );

}